import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "HttpClient";

export const GetAllRunCreation = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.NGSLis.RunCreation.GetAll}`,
    queryModel
  );
};

export const DeleteOrRejectRunCreation = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.NGSLis.RunCreation.DeleteOrReject}`,
    queryModel
  );
};

export const BulkCompleteNgsRun = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.NGSLis.RunCreation.BulkCompleteNgsRun}`,
    queryModel
  );
};

export const BulkReRun = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.NGSLis.RunCreation.BulkReRun}`,
    queryModel
  );
};

export const GetRunStatusLookup = () => {
  return HttpClient().get(
    `/${apiRoutes.NGSLis.RunCreation.GetRunStatusLookup}`
  );
};

export const GetNGSRunsLookup = () => {
  return HttpClient().get(`/${apiRoutes.NGSLis.RunCreation.GetNGSRunsLookup}`);
};

export const SaveRunCreation = (queryModel: any) => {
  return HttpClient().post(`/${apiRoutes.NGSLis.RunCreation.Save}`, queryModel);
};

export const SaveWellNoWithAccessions = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.NGSLis.RunCreation.SaveWellNoWithAccessions}`,
    queryModel
  );
};

export const GetWellNoApiCall = (id: any) => {
  return HttpClient().post(
    `/${apiRoutes.NGSLis.RunCreation.GetWellNoWithAccessionById}/${id}`
  );
};
